import { render, staticRenderFns } from "./TestRecords.vue?vue&type=template&id=3b4cd226&"
import script from "./TestRecords.vue?vue&type=script&lang=js&"
export * from "./TestRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports